import {CREATE_COURSE_CATEGORY, CREATE_COURSE_CATEGORY_FAILED, CREATE_COURSE_CATEGORY_SUCCESS} from "../actions";

export const createCourseCategoryCreator = (name, courseCategoryCreated) => ({
        type: CREATE_COURSE_CATEGORY,
        name: name,
        courseCategoryCreated: courseCategoryCreated
    }),
    createCourseCategorySuccessCreator = courseCategories => ({type: CREATE_COURSE_CATEGORY_SUCCESS, courseCategories: courseCategories}),
    createCourseCategoryFailedCreator = () => ({type: CREATE_COURSE_CATEGORY_FAILED});